<template>
  <div
    v-if="!props.isLastPage"
    class="FilterResults__footer"
  >
    <VisionButton
      button-text="Show more"
      background-colour="gradient"
      @click="handleClick"
    />
  </div>
</template>

<script setup>
const { $track } = useNuxtApp()

const props = defineProps({
  isLastPage: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['show-more'])

function handleClick() {
  emits('show-more')

  $track.global.linkClicked({
    interactionElement: 'Show more',
    interactionSection: 'Filter results'
  })
}
</script>

